const BULLET_POINTS = {
  one: '1',
  two: '2',
  three: '3',
};

export default BULLET_POINTS;
